import { Alert } from '@material-ui/lab';
import React from 'react';

export const Error = ({
  errorMessage = '',
  onClose
}: { errorMessage: string, onClose?: () => void }) => {
  if (!errorMessage.length) {
    return null;
  }

  return <Alert variant='standard'
                severity='error'
                onClose={onClose}>
    {errorMessage}
  </Alert>;
};
